var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-alert',{staticStyle:{"width":"100%"},attrs:{"type":"info","outlined":""}},[_vm._v(" There are no results at this moment ")])
}
var staticRenderFns = []

export { render, staticRenderFns }